module.exports = __webpack_public_path__ + "static/media/5_16.56489073.png";